import axiosInstance from "./axiosInstance";

export function checkPermission(permission) {
  const permissions = JSON.parse(localStorage.getItem("permissions")) || [];

  return permissions.includes(permission);
}

export const fetchAndStorePermissions = async () => {
  try {
    const response = await axiosInstance.get(
      `${process.env.REACT_APP_API_URL}/user-permissions`,
    );
    const permissionNames = response.data.map((permission) => permission.name);
    localStorage.setItem("permissions", JSON.stringify(permissionNames));
  } catch (error) {}
};
